import React from "react";
import { printImg } from "../../master/Print";
import useAppConfig from "../../config/useAppConfig";
import StudentDemoForm1 from "../components/StudentDemoForm1";
import StudentDemoForm2 from "../components/StudentDemoForm2";
import usePrivateLink from "../../config/usePrivateLink";

export default function StudentDemoForm({ data }) {
  const config = useAppConfig("Student", "student_demo_form");
  const hasAccess = usePrivateLink();

  return (
    <div className="card">
      <div className="card-body  overflow-auto">
        <div className="row">
          <div className="col-12 text-end mb-1">
            {hasAccess("/demo/form/print") &&
              <button
                className="btn btn-info"
                onClick={() => printImg("PrintDiv")}
              >
                <i className="ri-printer-line"></i>
              </button>
            }
          </div>
          <div className="col-12">
            {config?.value === "student_demo_form_1" ? (
              <StudentDemoForm1 data={data} />
            ) : config?.value === "student_demo_form_2" && (
              <StudentDemoForm2 data={data} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
